import React, { useState, useEffect, useRef } from 'react';
import { TipTapEditor } from '../../TipTap';

// MUI
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const EditorContainer = styled(Box)(({ disabled }) => ({
  '& .tiptap-editor-container': {
    border: '1px solid #ccc !important',
    borderRadius: '4px',
  },
  ...(disabled && {
    pointerEvents: 'none',
    opacity: 0.7,
    '& .tiptap-editor-container': {
      backgroundColor: 'rgba(248, 248, 248, 1) !important',
    },
  }),
}));

function RichTextInput({ data }) {
  const {
    answers,
    column,
    rowIndex,
    columnIndex,
    updateValue,
    isReadOnly,
    isRS,
  } = data;

  const editorRef = useRef(null);
  const [content, setContent] = useState('');

  useEffect(() => {
    const currentValue = answers[rowIndex][columnIndex].calculatedValue;
    if (currentValue && currentValue !== content) {
      setContent(currentValue);
    }
  }, []);

  // For deleting a row in repeatable sections
  useEffect(() => {
    if (isRS) {
      const currentValue = answers[rowIndex][columnIndex].calculatedValue;
      if (currentValue !== content) {
        setContent(currentValue || '');
      }
    }
  }, [answers]);

  const handleBlur = (newContent) => {
    if (newContent !== answers[rowIndex][columnIndex].calculatedValue) {
      setContent(newContent);
      updateValue(rowIndex, columnIndex, newContent, false);
    }
  };

  const handleChange = (newContent) => {
    setContent(newContent);
  };

  return (
    <EditorContainer
      disabled={isReadOnly}
      id={`table-row-${rowIndex}-col-${columnIndex}`}
    >
      <TipTapEditor
        ref={editorRef}
        value={content}
        onChange={handleChange}
        onBlur={handleBlur}
        readOnly={isReadOnly}
        showToolbar={!isReadOnly}
        minHeight="150px"
      />
    </EditorContainer>
  );
}

export default RichTextInput;
